import xs, { Stream } from 'xstream';
import fromEvent from 'xstream/extra/fromEvent';
import { Driver } from '../core/core-types';

export function makeCustomElementDriver(
    node: Element
): Driver<Stream<OutgoingEvents>, CustomElementSource> {
    return (sink$: Stream<OutgoingEvents>): CustomElementSource => {
        sink$.addListener({
            next: generateOutgoingEventsForElement.bind(null, node)
        });
        return new CustomElementSource(node);
    };
}

export interface OutgoingEvents {
    [eventName: string]: Stream<any>;
}

export class CustomElementSource {
    constructor(private _el: Element) { }
    event(eventName: string): Stream<Event> {
        return fromEvent(this._el, eventName);
    }
}

function generateOutgoingEventsForElement(
    node: Element,
    outgoingEvents: OutgoingEvents
): void {
    Object.keys(outgoingEvents).forEach(eventName => {
        outgoingEvents[eventName].addListener({
            next(detail: any): void {
                const event: CustomEvent = new CustomEvent(eventName, {
                    bubbles: true,
                    detail
                });
                node.dispatchEvent(event);
            }
        });
    });
}
